module.exports = __webpack_public_path__ + "static/media/pic4.abe03d39.jpg";